import './style.css';
import ListItem from './ListItem/ListItem';

const List = ({ list }) => {
    return (
        <div className='list-wrap'>
    {list.map((item) => (
      <ListItem key={item.id} item={item} />
    ))}
  </div>
    );
};

export default List;